import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=32939d3f&scoped=true&"
var script = {}
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=32939d3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32939d3f",
  null
  
)

export default component.exports